import { ICommercialSpecialtySchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { FOfferType } from '../../../../utils/offer_type';

interface IShouldSpecialtyRender {
  specialty: ICommercialSpecialtySchema | null;
  specialtiesString?: string;
  offerType: FOfferType;
}

export function shouldSpecialtyRender(params: IShouldSpecialtyRender): boolean {
  const { specialty, offerType, specialtiesString } = params;

  return Boolean(
    specialty &&
      (specialty.specialties || specialty.additionalTypes) &&
      [FOfferType.Business, FOfferType.FreeAppointmentObject, FOfferType.TradeArea].includes(offerType) &&
      !!specialtiesString,
  );
}
